import { Identifiable, ProjectResource, Resource } from "@planzone/dto";
import { HttpClient } from "../types/httpClient";
import { linkTask } from "./task";
import { linkZone } from "./zone";
import { linkList } from "./list";
import { linkPlanzone } from "./planzone";
import { linkProject } from "./project";
import { linkResource } from "./resource";
import { linkProjectResource } from "./projectResource";
import { linkPlanzoneResourceGroup } from "./planzoneResourceGroup";
import { linkProjectResourceGroup } from "./projectResourceGroup";
import { linkEvent } from "./event";
import { LinkedResource, Linker } from "./types";

function createLinker(httpClient: HttpClient): Linker {
  return {
    linkList: linkList(httpClient),
    linkPlanzone: linkPlanzone(httpClient),
    linkProject: linkProject(httpClient),
    linkResource: linkResource(httpClient),
    linkTask: linkTask(httpClient),
    linkEvent: linkEvent(httpClient),
    linkZone: linkZone(httpClient),
    linkProjectResource: linkProjectResource(httpClient),
    linkPlanzoneResourceGroup: (group: any) =>
      linkPlanzoneResourceGroup(httpClient)(group).then((group) =>
        Promise.all(
          group.resources.map((resource) =>
            linkResource(httpClient)(
              resource as LinkedResource<Identifiable<Resource>>,
            ),
          ),
        ).then((resources) => ({ ...group, resources })),
      ),
    linkProjectResourceGroup: (group: any) =>
      linkProjectResourceGroup(httpClient)(group).then((group) =>
        Promise.all(
          group.resources.map((projectResource) =>
            linkProjectResource(httpClient)(
              projectResource as LinkedResource<Identifiable<ProjectResource>>,
            ),
          ),
        ).then((resources) => ({ ...group, resources })),
      ),
  };
}

export { createLinker };
